import type { ReactNode } from 'react'
import { getAutoTitleColor } from '@/features/instructions/lib/gradientTextColor'
import { Type2Banner } from './Type2Banner'
import { Type2Square } from './Type2Square'

type ImageMode = 'square' | 'fill'

interface Props {
  variant: 'banner' | 'square'
  title: string
  gradient: string | null
  cardImage: string | null
  titleColor?: string | null
  authorName?: string | null
  authorAvatar?: string | null
  viewsCount?: number
  className?: string
  onMediaClick?: () => void
  placeholder?: ReactNode
  titleFontSize?: string
  titleFontWeight?: number | string
  badgeSize?: 'sm' | 'lg'
  imageMode?: ImageMode
}

const DEFAULT_BG = '#777777'

export const Type2Cover = ({
  variant,
  title,
  gradient,
  cardImage,
  titleColor,
  authorName,
  authorAvatar,
  viewsCount = 0,
  className,
  onMediaClick,
  placeholder,
  titleFontSize,
  titleFontWeight = 400,
  badgeSize = 'lg',
  imageMode = 'square',
}: Props) => {
  const bg = gradient ?? DEFAULT_BG
  const color = titleColor ?? getAutoTitleColor(bg)

  if (variant === 'banner') {
    return (
      <Type2Banner
        title={title}
        bg={bg}
        color={color}
        titleSize={titleFontSize ?? 'clamp(20px, 4.2vw, 56px)'}
        titleFontWeight={titleFontWeight}
        cardImage={cardImage}
        onMediaClick={onMediaClick}
        placeholder={placeholder}
        className={className}
      />
    )
  }

  return (
    <Type2Square
      title={title}
      bg={bg}
      color={color}
      titleSize={titleFontSize ?? 'clamp(14px, 3.4vw, 28px)'}
      titleFontWeight={titleFontWeight}
      cardImage={cardImage}
      authorName={authorName}
      authorAvatar={authorAvatar}
      viewsCount={viewsCount}
      badgeSize={badgeSize}
      imageMode={imageMode}
      onMediaClick={onMediaClick}
      placeholder={placeholder}
      className={className}
    />
  )
}
